import { AlertBox, Box, Button, FlexBox, Icon, Typography, getTokenCssVar } from '@vp/swan';
import { __ } from '@99designs/i18n';

/**
 * Shown when the server rejects a send with `conversation_stale` — the conversation on
 * screen no longer matches the one the service holds, because another tab sent a
 * message or because a send timed out client-side after the service had already
 * persisted it.
 *
 * The recovery is a full page reload, matching the pilot. An in-place refetch looks
 * tidier but has to decide what happens to the half-typed input, the locally appended
 * messages and the turn counter; reloading resets all three correctly by construction,
 * on a path that should almost never run.
 *
 * `warning` rather than `error`: nothing is broken and nothing was lost — the view is
 * simply behind.
 */
export function ChatStaleBanner() {
    return (
        <Box style={{ width: '100%', paddingBottom: getTokenCssVar('SwanSemSpace4') }}>
            <AlertBox skin="warning" toast={false} accessibleTextForIcon={__('Warning')}>
                <FlexBox alignItems="flex-start" justifyContent="space-between" gap="4">
                    <Typography fontSkin="body-standard">
                        {__(
                            'Your chat session is out of date. Please refresh the page to proceed.'
                        )}
                    </Typography>
                    <Button skin="link" onClick={() => window.location.reload()}>
                        <FlexBox alignItems="center" gap="3">
                            <Box style={{ flexShrink: 0 }}>
                                <Icon iconType="reset" size="small" />
                            </Box>
                            <Box>{__('Refresh page')}</Box>
                        </FlexBox>
                    </Button>
                </FlexBox>
            </AlertBox>
        </Box>
    );
}
